// IB subject/topic/subtopic tree for the Recall active-recall study tool.
export const RECALL_SUBJECTS = [
  { name: 'Chemistry', level: 'SL', topics: [
    { name: 'Structure 1 · Particulate nature of matter', subs: [
      { code: 'S1.1', name: 'States of matter & changes of state' },
      { code: 'S1.2', name: 'The nuclear atom' },
      { code: 'S1.3', name: 'Electron configurations' },
      { code: 'S1.4', name: 'Counting particles: the mole' },
      { code: 'S1.5', name: 'Ideal gases' } ] },
    { name: 'Structure 2 · Bonding & structure', subs: [
      { code: 'S2.1', name: 'The ionic model' },
      { code: 'S2.2', name: 'The covalent model' },
      { code: 'S2.3', name: 'The metallic model' },
      { code: 'S2.4', name: 'From models to materials' } ] },
    { name: 'Structure 3 · Classification of matter', subs: [
      { code: 'S3.1', name: 'The periodic table' },
      { code: 'S3.2', name: 'Functional groups' } ] },
    { name: 'Reactivity 1 · Energy changes', subs: [
      { code: 'R1.1', name: 'Enthalpy changes' },
      { code: 'R1.2', name: 'Energy cycles' },
      { code: 'R1.3', name: 'Energy from fuels' } ] },
    { name: 'Reactivity 2 · How much, how fast, how far', subs: [
      { code: 'R2.1', name: 'Amount of chemical change' },
      { code: 'R2.2', name: 'Rate of chemical change' },
      { code: 'R2.3', name: 'Extent of chemical change' } ] },
    { name: 'Reactivity 3 · Mechanisms of change', subs: [
      { code: 'R3.1', name: 'Proton transfer: acids & bases' },
      { code: 'R3.2', name: 'Electron transfer: redox' },
      { code: 'R3.3', name: 'Electron sharing: radicals' },
      { code: 'R3.4', name: 'Electron-pair sharing: nucleophiles' } ] } ] },
  { name: 'Business Management', level: 'HL', topics: [
    { name: 'Unit 1 · Introduction to business', subs: [
      { code: '1.1', name: 'What is a business?' },
      { code: '1.2', name: 'Types of business entities' },
      { code: '1.3', name: 'Business objectives' },
      { code: '1.4', name: 'Stakeholders' },
      { code: '1.5', name: 'Growth & evolution' },
      { code: '1.6', name: 'Multinational companies' } ] },
    { name: 'Unit 2 · Human resource management', subs: [
      { code: '2.1', name: 'Introduction to HRM' },
      { code: '2.2', name: 'Organisational structure' },
      { code: '2.3', name: 'Leadership & management' },
      { code: '2.4', name: 'Motivation & demotivation' },
      { code: '2.5', name: 'Organisational culture' },
      { code: '2.6', name: 'Communication' },
      { code: '2.7', name: 'Industrial relations' } ] },
    { name: 'Unit 3 · Finance & accounts', subs: [
      { code: '3.1', name: 'Sources of finance' },
      { code: '3.2', name: 'Costs & revenues' },
      { code: '3.3', name: 'Break-even analysis' },
      { code: '3.4', name: 'Final accounts' },
      { code: '3.5', name: 'Profitability & liquidity ratios' },
      { code: '3.6', name: 'Efficiency ratios' },
      { code: '3.7', name: 'Cash flow' },
      { code: '3.8', name: 'Investment appraisal' },
      { code: '3.9', name: 'Budgets' } ] },
    { name: 'Unit 4 · Marketing', subs: [
      { code: '4.1', name: 'Introduction to marketing' },
      { code: '4.2', name: 'Marketing planning' },
      { code: '4.3', name: 'Sales forecasting' },
      { code: '4.4', name: 'Market research' },
      { code: '4.5', name: 'The seven Ps of the marketing mix' },
      { code: '4.6', name: 'International marketing' } ] },
    { name: 'Unit 5 · Operations management', subs: [
      { code: '5.1', name: 'Introduction to operations' },
      { code: '5.2', name: 'Operations methods' },
      { code: '5.3', name: 'Lean production & quality management' },
      { code: '5.4', name: 'Location' },
      { code: '5.5', name: 'Production planning' },
      { code: '5.6', name: 'Crisis management & contingency planning' },
      { code: '5.7', name: 'Research & development' },
      { code: '5.8', name: 'Management information systems' } ] } ] },
  { name: 'Economics', level: 'HL', topics: [
    { name: 'Unit 1 · Introduction to economics', subs: [
      { code: '1.1', name: 'What is economics?' },
      { code: '1.2', name: 'How do economists approach the world?' } ] },
    { name: 'Unit 2 · Microeconomics', subs: [
      { code: '2.1', name: 'Demand' },
      { code: '2.2', name: 'Supply' },
      { code: '2.3', name: 'Competitive market equilibrium' },
      { code: '2.4', name: 'Critique of maximising behaviour' },
      { code: '2.5', name: 'Elasticity of demand' },
      { code: '2.6', name: 'Elasticity of supply' },
      { code: '2.7', name: 'Role of government in microeconomics' },
      { code: '2.8', name: 'Market failure — externalities' },
      { code: '2.9', name: 'Market failure — public goods' },
      { code: '2.10', name: 'Market failure — asymmetric information' },
      { code: '2.11', name: 'Market failure — market power' },
      { code: '2.12', name: "The market's inability to achieve equity" } ] },
    { name: 'Unit 3 · Macroeconomics', subs: [
      { code: '3.1', name: 'Measuring economic activity' },
      { code: '3.2', name: 'Variations in economic activity' },
      { code: '3.3', name: 'Macroeconomic objectives' },
      { code: '3.4', name: 'Economics of inequality & poverty' },
      { code: '3.5', name: 'Demand-side policies' },
      { code: '3.6', name: 'Supply-side policies' } ] },
    { name: 'Unit 4 · The global economy', subs: [
      { code: '4.1', name: 'Benefits of international trade' },
      { code: '4.2', name: 'Types of trade protection' },
      { code: '4.3', name: 'Arguments for & against trade control' },
      { code: '4.4', name: 'Economic integration' },
      { code: '4.5', name: 'Exchange rates' },
      { code: '4.6', name: 'Balance of payments' },
      { code: '4.7', name: 'Sustainable development' },
      { code: '4.8', name: 'Measuring development' },
      { code: '4.9', name: 'Barriers to development' },
      { code: '4.10', name: 'Strategies for growth & development' } ] } ] },
];
